
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker } from '@/components';
import { AppFileUpload, AppImageHolder } from '@/components';
import { useDuplicateItemAdd } from '@/modules/duplicate/item/model/add';
import { DuplicateItemOptions } from '@/modules/duplicate/item/model/mixins';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.ITEM.ADD,
    components: {
        AppFormRow,
        AppInput,
        AppCard,
        AppButton,
        AppSelect,
        AppDateTimePicker,
        AppFileUpload,
        AppImageHolder
    },
    setup() {
        const { model, v$, fetchAllMatches, gameMatchOptions, timeUnits, create } = useDuplicateItemAdd();

        onMounted(async () => {
            await fetchAllMatches();
        });

        return { v$, model, create, gameMatchOptions, timeUnits, DuplicateItemOptions };
    }
});
